export default __webpack_public_path__ + "static/media/Without_permission.f0601378.png";